import { render, staticRenderFns } from "./message-compose.vue?vue&type=template&id=74af6280&scoped=true"
import script from "./message-compose.vue?vue&type=script&lang=js"
export * from "./message-compose.vue?vue&type=script&lang=js"
import style0 from "./message-compose.vue?vue&type=style&index=0&id=74af6280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af6280",
  null
  
)

export default component.exports